import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { ImportadorService } from '../services/importador.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ImportadorGuard implements CanActivate {

  constructor(private importadorService: ImportadorService, private userService: UserService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.importadorService.verificarPermiso().pipe(
      map(permiso => {
        if (!permiso) {
          return this.router.createUrlTree([this.userService.getPrimeraRutaPermitida()]);
        }
        return true;
      })
    );
  }
}
